function ListItem({ ref, value }) {
  return <div ref={ref}>{value.id}</div>
}

export default ListItem
